import { onSnapshot, types } from "mobx-state-tree";

const HelperInfo = types
  .model({
    isOpen: false,
  })
  .actions((self) => ({
    toggle() {
      self.isOpen = !self.isOpen;
    },
  }));

export const helperInfo = HelperInfo.create({});
if (process.env.NODE_ENV == "development")
  onSnapshot(helperInfo, (newSnapshot) => {
    console.log("helper info snapshot: ", newSnapshot);
  });
